import { FormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

export class Funcoes {
  numeroPorExtenso(vlr) {
    var Num = parseFloat(vlr);
    if (vlr == 0) {
      return 'zero';
    } else {
      var inteiro = parseInt(vlr); // parte inteira do valor
      if (inteiro < 1000000000000000) {
        var resto = Number(Num.toFixed(2)) - Number(inteiro.toFixed(2)); // parte fracionária do valor
        resto = Number(resto.toFixed(2));
        var vlrS = inteiro.toString();
        var cont = vlrS.length;
        var extenso = '';
        var auxnumero;
        var auxnumero2;
        var auxnumero3;
        var unidade = [
          '',
          'um',
          'dois',
          'três',
          'quatro',
          'cinco',
          'seis',
          'sete',
          'oito',
          'nove',
          'dez',
          'onze',
          'doze',
          'treze',
          'quatorze',
          'quinze',
          'dezesseis',
          'dezessete',
          'dezoito',
          'dezenove',
        ];
        var centena = [
          '',
          'cento',
          'duzentos',
          'trezentos',
          'quatrocentos',
          'quinhentos',
          'seiscentos',
          'setecentos',
          'oitocentos',
          'novecentos',
        ];
        var dezena = [
          '',
          '',
          'vinte',
          'trinta',
          'quarenta',
          'cinquenta',
          'sessenta',
          'setenta',
          'oitenta',
          'noventa',
        ];
        var qualificaS = ['reais', 'mil', 'milhão', 'bilhão', 'trilhão'];
        var qualificaP = ['reais', 'mil', 'milhões', 'bilhões', 'trilhões'];
        for (var i = cont; i > 0; i--) {
          var verifica1 = '';
          var verifica2 = 0;
          var verifica3 = 0;
          auxnumero2 = '';
          auxnumero3 = '';
          auxnumero = 0;
          auxnumero2 = vlrS.substr(cont - i, 1);
          auxnumero = parseInt(auxnumero2);
          if (i == 14 || i == 11 || i == 8 || i == 5 || i == 2) {
            auxnumero2 = vlrS.substr(cont - i, 2);
            auxnumero = parseInt(auxnumero2);
          }
          if (i == 15 || i == 12 || i == 9 || i == 6 || i == 3) {
            extenso = extenso + centena[auxnumero];
            auxnumero2 = vlrS.substr(cont - i + 1, 1);
            auxnumero3 = vlrS.substr(cont - i + 2, 1);
            if (auxnumero2 != '0' || auxnumero3 != '0') extenso += ' e ';
          } else if (auxnumero > 19) {
            auxnumero2 = vlrS.substr(cont - i, 1);
            auxnumero = parseInt(auxnumero2);
            extenso = extenso + dezena[auxnumero];
            auxnumero3 = vlrS.substr(cont - i + 1, 1);
            if (auxnumero3 != '0' && auxnumero2 != '1') extenso += ' e ';
          } else if (
            auxnumero <= 19 &&
            auxnumero > 9 &&
            (i == 14 || i == 11 || i == 8 || i == 5 || i == 2)
          ) {
            extenso = extenso + unidade[auxnumero];
          } else if (
            auxnumero < 10 &&
            (i == 13 || i == 10 || i == 7 || i == 4 || i == 1)
          ) {
            auxnumero3 = vlrS.substr(cont - i - 1, 1);
            if (auxnumero3 != '1' && auxnumero3 != '')
              extenso = extenso + unidade[auxnumero];
          }
          if (i % 3 == 1) {
            verifica3 = cont - i;
            if (verifica3 == 0) verifica1 = vlrS.substr(cont - i, 1);
            if (verifica3 == 1) verifica1 = vlrS.substr(cont - i - 1, 2);
            if (verifica3 > 1) verifica1 = vlrS.substr(cont - i - 2, 3);
            verifica2 = parseInt(verifica1);
            if (i == 13) {
              if (verifica2 == 1) {
                extenso = extenso + ' ' + qualificaS[4] + ' ';
              } else if (verifica2 != 0) {
                extenso = extenso + ' ' + qualificaP[4] + ' ';
              }
            }
            if (i == 10) {
              if (verifica2 == 1) {
                extenso = extenso + ' ' + qualificaS[3] + ' ';
              } else if (verifica2 != 0) {
                extenso = extenso + ' ' + qualificaP[3] + ' ';
              }
            }
            if (i == 7) {
              if (verifica2 == 1) {
                extenso = extenso + ' ' + qualificaS[2] + ' ';
              } else if (verifica2 != 0) {
                extenso = extenso + ' ' + qualificaP[2] + ' ';
              }
            }
            if (i == 4) {
              if (verifica2 == 1) {
                extenso = extenso + ' ' + qualificaS[1] + ' ';
              } else if (verifica2 != 0) {
                extenso = extenso + ' ' + qualificaP[1] + ' ';
              }
            }
            if (i == 1) {
              if (verifica2 == 1) {
                extenso = extenso + ' ' + qualificaS[0] + ' ';
              } else {
                extenso = extenso + ' ' + qualificaP[0] + ' ';
              }
            }
          }
        }
        resto = resto * 100;
        var aexCent = 0;
        if (resto <= 19 && resto > 0)
          extenso += ' e ' + unidade[resto] + ' Centavos';
        if (resto > 19) {
          aexCent = resto / 10;
          extenso += ' e ' + dezena[aexCent];
          resto = resto - aexCent * 10;
          if (resto != 0) extenso += ' e ' + unidade[resto] + ' Centavos';
          else extenso += ' Centavos';
        }
        return extenso;
      } else {
        return 'Numero maior que 999 trilhões';
      }
    }
  }
  titleCase(str) {
    return str.replace(/\w\S*/g, function (str) {
      return str.charAt(0).toUpperCase() + str.substr(1).toLowerCase();
    });
  }
  mascaraCpf(valor) {
    if (valor.length <= 11) {
      return valor.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
    } else {
      return valor.replace(
        /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,
        '$1.$2.$3/$4-$5'
      );
    }
  }
  mascaraCnpj(valor) {
    return valor.replace(
      /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,
      '$1.$2.$3/$4-$5'
    );
  }
  formatarMoeda(valor) {
    var valor = valor;
    valor = valor + '';
    valor = parseInt(valor.replace(/[\D]+/g, ''));
    valor = valor + '';
    valor = valor.replace(/([0-9]{2})$/g, ',$1');
    if (valor.length > 6) {
      valor = valor.replace(/([0-9]{3}),([0-9]{2}$)/g, '.$1,$2');
    }

    return 'R$ ' + valor;
  }
  getFormattedPrice(price: number) {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(price);
  }
  retornaMeses() {
    return [
      {
        mes: 'Janeiro',
        numero: '01',
        inicio: `01-01`,
        fim: `01-${new Date(2021, 0 + 1, 0).getDate()}`,
      },
      {
        mes: 'Fevereiro',
        numero: '02',
        inicio: `02-01`,
        fim: `02-${new Date(2021, 1 + 1, 0).getDate()}`,
      },
      {
        mes: 'Março',
        numero: '03',
        inicio: `03-01`,
        fim: `03-${new Date(2021, 2 + 1, 0).getDate()}`,
      },
      {
        mes: 'Abril',
        numero: '04',
        inicio: `04-01`,
        fim: `04-${new Date(2021, 3 + 1, 0).getDate()}`,
      },
      {
        mes: 'Maio',
        numero: '05',
        inicio: `05-01`,
        fim: `05-${new Date(2021, 4 + 1, 0).getDate()}`,
      },
      {
        mes: 'Junho',
        numero: '06',
        inicio: `06-01`,
        fim: `06-${new Date(2021, 5 + 1, 0).getDate()}`,
      },
      {
        mes: 'Julho',
        numero: '07',
        inicio: `07-01`,
        fim: `07-${new Date(2021, 6 + 1, 0).getDate()}`,
      },
      {
        mes: 'Agosto',
        numero: '08',
        inicio: `08-01`,
        fim: `08-${new Date(2021, 7 + 1, 0).getDate()}`,
      },
      {
        mes: 'Setembro',
        numero: '09',
        inicio: `09-01`,
        fim: `09-${new Date(2021, 8 + 1, 0).getDate()}`,
      },
      {
        mes: 'Outubro',
        numero: '10',
        inicio: `10-01`,
        fim: `10-${new Date(2021, 9 + 1, 0).getDate()}`,
      },
      {
        mes: 'Novembro',
        numero: '11',
        inicio: `11-01`,
        fim: `11-${new Date(2021, 10 + 1, 0).getDate()}`,
      },
      {
        mes: 'Dezembro',
        numero: '12',
        inicio: `12-01`,
        fim: `12-${new Date(2021, 11 + 1, 0).getDate()}`,
      },
    ];
  }
  // gera_cor() {
  //   var hexadecimais = '0123456789ABCDEF';
  //   var cor = '#';
  //   for (var i = 0; i < 6; i++) {
  //     cor += hexadecimais[Math.floor(Math.random() * 16)];
  //   }
  //   return cor;
  // }

  Extenso(numero) {
    var retorno = '';
    var auxiliar1 = [
      'zero',
      'um',
      'dois',
      'três',
      'quatro',
      'cinco',
      'seis',
      'sete',
      'oito',
      'nove',
      'dez',
      'onze',
      'doze',
      'treze',
      'quatorze',
      'quinze',
      'dezesseis',
      'dezessete',
      'dezoito',
      'dezenove',
    ];
    var auxiliar2 = [
      'dez',
      'vinte',
      'trinta',
      'quarenta',
      'cinqüenta',
      'sessenta',
      'setenta',
      'oitenta',
      'noventa',
    ];
    console.log(numero);
    if (numero > 99) {
      retorno = 'Não posso calcular';
    } else {
      if (numero < 20) {
        retorno = auxiliar1[numero];
      } else {
        var temp = numero.toString().split('');
        var primeiro_numero = temp[0];
        var segundo_numero = temp[1];
        retorno = auxiliar2[primeiro_numero - 1];
        if (segundo_numero > 0) {
          retorno += ' e ' + auxiliar1[primeiro_numero];
        }
      }
    }
    return retorno;
  }

  //VALIDAÇÃO DE CPF
  public static cpf(cpf: string): boolean {
    if (cpf == null) {
      return false;
    }
    if (cpf.length != 11) {
      return false;
    }
    if (
      cpf == '00000000000' ||
      cpf == '11111111111' ||
      cpf == '22222222222' ||
      cpf == '33333333333' ||
      cpf == '44444444444' ||
      cpf == '55555555555' ||
      cpf == '66666666666' ||
      cpf == '77777777777' ||
      cpf == '88888888888' ||
      cpf == '99999999999'
    ) {
      return false;
    }
    let numero: number = 0;
    let caracter: string = '';
    let numeros: string = '0123456789';
    let j: number = 10;
    let somatorio: number = 0;
    let resto: number = 0;
    let digito1: number = 0;
    let digito2: number = 0;
    let cpfAux: string = '';
    cpfAux = cpf.substring(0, 9);
    for (let i: number = 0; i < 9; i++) {
      caracter = cpfAux.charAt(i);
      if (numeros.search(caracter) == -1) {
        return false;
      }
      numero = Number(caracter);
      somatorio = somatorio + numero * j;
      j--;
    }
    resto = somatorio % 11;
    digito1 = 11 - resto;
    if (digito1 > 9) {
      digito1 = 0;
    }
    j = 11;
    somatorio = 0;
    cpfAux = cpfAux + digito1;
    for (let i: number = 0; i < 10; i++) {
      caracter = cpfAux.charAt(i);
      numero = Number(caracter);
      somatorio = somatorio + numero * j;
      j--;
    }
    resto = somatorio % 11;
    digito2 = 11 - resto;
    if (digito2 > 9) {
      digito2 = 0;
    }
    cpfAux = cpfAux + digito2;
    if (cpf != cpfAux) {
      return false;
    } else {
      return true;
    }
  }

  //Função que irá testar se o CNPJ é valido
  public static cnpj(cnpj: string): boolean {
    // Verifica se a variável cnpj é igual a "undefined", retornando false
    if (cnpj === undefined) {
      return false;
    }

    // Esta função retira os caracteres . / - da string do cnpj, deixando apenas os números
    let strCNPJ: any = cnpj
      .replace('.', '')
      .replace('.', '')
      .replace('/', '')
      .replace('-', '');

    // Testa as sequências que possuem todos os dígitos iguais e se o cnpj não tem 14 dígitos, retonando false
    if (
      strCNPJ === '00000000000000' ||
      strCNPJ === '11111111111111' ||
      strCNPJ === '22222222222222' ||
      strCNPJ === '33333333333333' ||
      strCNPJ === '44444444444444' ||
      strCNPJ === '55555555555555' ||
      strCNPJ === '66666666666666' ||
      strCNPJ === '77777777777777' ||
      strCNPJ === '88888888888888' ||
      strCNPJ === '99999999999999' ||
      strCNPJ.length !== 14
    ) {
      return false;
    }

    // A variável numeros pega o bloco com os números sem o DV, a variável digitos pega apenas os dois últimos números (Dígito Verificador).
    let tamanho: any = strCNPJ.length - 2;
    let numeros: any = strCNPJ.substring(0, tamanho);
    let digitos: any = strCNPJ.substring(tamanho);
    let soma: any = 0;
    let pos: any = tamanho - 7;

    // Os quatro blocos seguintes de funções irá reaizar a validação do CNPJ propriamente dito, conferindo se o DV bate. Caso alguma das funções não consiga verificar
    // o DV corretamente, retornará falso, para que o usário posso digitar novamente um número
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) {
        pos = 9;
      }
    }

    let resultado: any = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado != digitos.charAt(0)) {
      return false;
    }

    tamanho = tamanho + 1;
    numeros = strCNPJ.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let k = tamanho; k >= 1; k--) {
      soma += numeros.charAt(tamanho - k) * pos--;
      if (pos < 2) {
        pos = 9;
      }
    }

    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado != digitos.charAt(1)) {
      return false;
    }

    return true;
  }

  public static getBillingBasis({ billing_basis, quantity }): string {
    return `${(<string>billing_basis)?.replace(
      'ão',
      quantity != 1 ? 'õe' : 'ão'
    )}${quantity != 1 ? 's' : ''}`;
  }

  public static getFrequency({ frequency, quantity }): string {
    return `${(<string>frequency)?.replace('al', quantity != 1 ? 'ai' : 'al')}${
      quantity != 1 ? 's' : ''
    }`;
  }

  protected static states = {
    12: 'AC',
    27: 'AL',
    13: 'AM',
    16: 'AP',
    29: 'BA',
    23: 'CE',
    53: 'DF',
    32: 'ES',
    52: 'GO',
    21: 'MA',
    31: 'MG',
    50: 'MS',
    51: 'MT',
    15: 'PA',
    25: 'PB',
    26: 'PE',
    22: 'PI',
    41: 'PR',
    33: 'RJ',
    24: 'RN',
    11: 'RO',
    14: 'RR',
    43: 'RS',
    42: 'SC',
    28: 'SE',
    35: 'SP',
    17: 'TO',
  };

  static getUfAcronymByCode(uf_code) {
    return this.states[uf_code];
  }

  static getUfCodeByAcronym(uf_acronym) {
    return Object.entries(this.states).find(
      ([key, value]) => uf_acronym == value
    )[0];
  }

  static normalizeString(text: string): string {
    return text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }
}

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(
    control: FormControl | null,
    form: FormGroupDirective | NgForm | null
  ): boolean {
    const isSubmitted = form && form.submitted;
    return !!(
      control &&
      control.invalid &&
      (control.dirty || control.touched || isSubmitted)
    );
  }
}

export function generateRandomColor(previousColor?) {
  function generateRandomComponent() {
    return Math.floor(Math.random() * 256)
      .toString(16)
      .padStart(2, '0');
  }

  function generateColor() {
    return `#${generateRandomComponent()}${generateRandomComponent()}${generateRandomComponent()}`;
  }

  let newColor = generateColor();

  if (previousColor) {
    if (newColor === previousColor) {
      newColor = `#${(parseInt(newColor.slice(1, 3), 16) ^ 128).toString(
        16
      )}${newColor.slice(3)}`;
    }
  }

  return newColor;
}

export function generateQueryString(params) {
  let queryString = '';

  let counter = 0;
  for (let key in params) {
    if (params[key]) {
      queryString += `${key}=${params[key]}`
      let paramsLength = Object.values(params).filter((value) => value).length
      if (counter < (paramsLength - 1)) {
        queryString += `&`
      }
      counter++
    }
  }

  return queryString;
}
